import { render, staticRenderFns } from "./DownloadReglementFile.vue?vue&type=template&id=3346d25c"
import script from "./DownloadReglementFile.vue?vue&type=script&lang=js"
export * from "./DownloadReglementFile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports